module.exports = __webpack_public_path__ + "img/19.17f1078c.png";